"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _linkaddress = _interopRequireDefault(require("@/components/linkaddress"));
var fudouActiveApi = _interopRequireWildcard(require("@/api/fudouActiveApi.js"));
var _hotspotUtils = require("../hotspotUtils");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _excluded = ["_isDisplay"];
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'setHotspot',
  components: {
    linkaddressVue: _linkaddress.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      userType: null,
      form: {
        pic: '',
        clickList: []
      },
      itemIndex: null,
      hotspotIndex: null,
      mapping: null,
      isActive: false,
      autoList: [],
      // 添加图片原始尺寸和当前显示尺寸，用于计算缩放比例
      imageNaturalWidth: 0,
      imageNaturalHeight: 0,
      imageDisplayWidth: 0,
      imageDisplayHeight: 0,
      scaleX: 1,
      scaleY: 1,
      // 保存原始图片尺寸（用于坐标转换），这些值来自 picW 和 picH，或者 naturalWidth/naturalHeight
      originalPicWidth: 0,
      originalPicHeight: 0,
      imageReady: false,
      resizeTimer: null
    };
  },
  computed: {
    isMiniProgramCustomer: function isMiniProgramCustomer() {
      return Number(this.userType) === 5;
    }
  },
  mounted: function mounted() {
    try {
      var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
      this.userType = JavaInfo.type;
    } catch (e) {
      this.userType = null;
    }
    this.handleOffsetLIstanbul();
    // 监听窗口大小变化，当浏览器缩放时会触发
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = null;
    }
    // 清理事件监听器
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('mousemove', this.mousemove);
    window.removeEventListener('mouseup', this.mouseup);
    window.removeEventListener('mousemove', this.scaleMousemove);
    window.removeEventListener('mouseup', this.scaleMouseup);
    window.removeEventListener('click', this.windowClick);
  },
  methods: {
    handleOffsetLIstanbul: function () {
      var _handleOffsetLIstanbul = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return fudouActiveApi.autoListByType({
                type: 4
              });
            case 1:
              res = _context.v;
              this.autoList = res;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleOffsetLIstanbul() {
        return _handleOffsetLIstanbul.apply(this, arguments);
      }
      return handleOffsetLIstanbul;
    }(),
    // 处理窗口大小变化（包括浏览器缩放）
    handleResize: function handleResize() {
      var _this = this;
      if (!this.dialogVisible) return;
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(function () {
        _this.resizeTimer = null;
        _this.$nextTick(function () {
          return _this.updateImageDimensions();
        });
      }, 150);
    },
    close: function close() {
      this.form = {
        pic: '',
        clickList: []
      };
      this.dialogVisible = false;
      this.imageReady = false;
      // 重置原始尺寸
      this.originalPicWidth = 0;
      this.originalPicHeight = 0;
      this.imageDisplayWidth = 0;
      this.imageDisplayHeight = 0;
    },
    /** 显示尺寸可信时才计算缩放，避免布局未完成时 scale 过小导致热区超大 */isDisplaySizeValid: function isDisplaySizeValid(width, height) {
      var MIN = 20;
      return width >= MIN && height >= MIN;
    },
    /** 将热区显示坐标限制在图片显示区域内 */clampDisplayCoords: function clampDisplayCoords(left, top, width, height) {
      var maxW = this.imageDisplayWidth;
      var maxH = this.imageDisplayHeight;
      var minSize = 10;
      if (!maxW || !maxH) {
        return {
          left: 0,
          top: 0,
          width: minSize,
          height: minSize
        };
      }
      var w = Math.max(minSize, Math.min(width, maxW));
      var h = Math.max(minSize, Math.min(height, maxH));
      var l = Math.max(0, left);
      var t = Math.max(0, top);
      if (l + w > maxW) l = maxW - w;
      if (t + h > maxH) t = maxH - h;
      l = Math.max(0, l);
      t = Math.max(0, t);
      return {
        left: l,
        top: t,
        width: w,
        height: h
      };
    },
    /** 将热区原始坐标限制在原图尺寸内 */clampOriginalCoords: function clampOriginalCoords(left, top, width, height) {
      var maxW = this.originalPicWidth;
      var maxH = this.originalPicHeight;
      var minSize = 1;
      if (!maxW || !maxH) {
        return {
          left: 0,
          top: 0,
          width: width,
          height: height
        };
      }
      var w = Math.max(minSize, Math.min(width, maxW));
      var h = Math.max(minSize, Math.min(height, maxH));
      var l = Math.max(0, Math.min(left, maxW - w));
      var t = Math.max(0, Math.min(top, maxH - h));
      return {
        left: l,
        top: t,
        width: w,
        height: h
      };
    },
    /** 同步单条热区的显示坐标与原始坐标，并钳制在图片范围内 */applyClampedHotspot: function applyClampedHotspot(item) {
      var orig = this.clampOriginalCoords(item.originalLeft !== undefined ? item.originalLeft : item.left / (this.scaleX || 1), item.originalTop !== undefined ? item.originalTop : item.top / (this.scaleY || 1), item.originalWidth !== undefined ? item.originalWidth : item.width / (this.scaleX || 1), item.originalHeight !== undefined ? item.originalHeight : item.height / (this.scaleY || 1));
      var left = orig.left * this.scaleX;
      var top = orig.top * this.scaleY;
      var width = orig.width * this.scaleX;
      var height = orig.height * this.scaleY;
      var display = this.clampDisplayCoords(left, top, width, height);
      if (this.scaleX > 0 && this.scaleY > 0) {
        return _objectSpread(_objectSpread({}, item), {}, {
          left: display.left,
          top: display.top,
          width: display.width,
          height: display.height,
          originalLeft: display.left / this.scaleX,
          originalTop: display.top / this.scaleY,
          originalWidth: display.width / this.scaleX,
          originalHeight: display.height / this.scaleY,
          _isDisplay: true
        });
      }
      return _objectSpread(_objectSpread({}, item), display);
    },
    clampAllHotspots: function clampAllHotspots() {
      var _this2 = this;
      if (!this.form.clickList || !this.form.clickList.length) return;
      if (!this.isDisplaySizeValid(this.imageDisplayWidth, this.imageDisplayHeight)) return;
      this.form.clickList.forEach(function (item, index) {
        _this2.$set(_this2.form.clickList, index, _this2.applyClampedHotspot(item));
      });
    },
    open: function open(data) {
      var _this3 = this;
      // 如果传入的数据包含 picW 和 picH，这些是原始图片尺寸
      if (data.picW && data.picH) {
        this.originalPicWidth = data.picW;
        this.originalPicHeight = data.picH;
      }

      // 处理旧数据格式：如果热区数据中没有 originalLeft 等字段，需要初始化
      if (data.clickList && data.clickList.length > 0) {
        data.clickList.forEach(function (item) {
          // 如果缺少原始坐标字段，假设当前 left/top/width/height 就是原始坐标
          // （这适用于旧数据，假设旧数据是相对于原始图片尺寸保存的）
          if (item.originalLeft === undefined) {
            item.originalLeft = item.left;
            item.originalTop = item.top;
            item.originalWidth = item.width;
            item.originalHeight = item.height;
            item._isDisplay = false; // 标记为原始坐标
          }
        });
      }

      // 修正存量越界数据（旧版按画布显示像素保存的坐标会远超 picW/picH）
      var normalized = (0, _hotspotUtils.normalizeHotspotData)(data);
      data = normalized.data;
      this.form = _objectSpread(_objectSpread({}, this.form), data);
      this.dialogVisible = true;
      this.imageReady = false;
      this.$nextTick(function () {
        requestAnimationFrame(function () {
          return _this3.updateImageDimensions();
        });
      });
    },
    onImageLoad: function onImageLoad() {
      var _this4 = this;
      this.$nextTick(function () {
        requestAnimationFrame(function () {
          return _this4.updateImageDimensions();
        });
      });
    },
    // 更新图片尺寸和缩放比例
    updateImageDimensions: function updateImageDimensions() {
      var imgElement = this.$refs.imageRef;
      if (!imgElement) return;
      var naturalW = imgElement.naturalWidth || 0;
      var naturalH = imgElement.naturalHeight || 0;
      if (naturalW <= 0 || naturalH <= 0) {
        this.imageReady = false;
        return;
      }
      var imgRect = imgElement.getBoundingClientRect();
      if (!this.isDisplaySizeValid(imgRect.width, imgRect.height)) {
        this.imageReady = false;
        return;
      }
      this.imageNaturalWidth = naturalW;
      this.imageNaturalHeight = naturalH;
      this.originalPicWidth = naturalW;
      this.originalPicHeight = naturalH;
      this.imageDisplayWidth = imgRect.width;
      this.imageDisplayHeight = imgRect.height;
      this.scaleX = this.imageDisplayWidth / this.originalPicWidth;
      this.scaleY = this.imageDisplayHeight / this.originalPicHeight;
      this.imageReady = true;
      if (this.form.clickList && this.form.clickList.length > 0) {
        this.convertOriginalToDisplayCoordinates();
        this.clampAllHotspots();
      }
    },
    // 将原始坐标转换为显示坐标（用于渲染）
    convertOriginalToDisplayCoordinates: function convertOriginalToDisplayCoordinates() {
      var _this5 = this;
      if (!this.form.clickList || this.form.clickList.length === 0) return;
      if (this.scaleX <= 0 || this.scaleY <= 0) return;
      this.form.clickList.forEach(function (item, index) {
        var originalLeft = item.originalLeft !== undefined ? item.originalLeft : item.left;
        var originalTop = item.originalTop !== undefined ? item.originalTop : item.top;
        var originalWidth = item.originalWidth !== undefined ? item.originalWidth : item.width;
        var originalHeight = item.originalHeight !== undefined ? item.originalHeight : item.height;
        var orig = _this5.clampOriginalCoords(originalLeft, originalTop, originalWidth, originalHeight);
        var display = _this5.clampDisplayCoords(orig.left * _this5.scaleX, orig.top * _this5.scaleY, orig.width * _this5.scaleX, orig.height * _this5.scaleY);
        _this5.$set(_this5.form.clickList, index, _objectSpread(_objectSpread({}, item), {}, {
          left: display.left,
          top: display.top,
          width: display.width,
          height: display.height,
          originalLeft: display.left / _this5.scaleX,
          originalTop: display.top / _this5.scaleY,
          originalWidth: display.width / _this5.scaleX,
          originalHeight: display.height / _this5.scaleY,
          _isDisplay: true
        }));
      });
    },
    // 将显示坐标转换为原始坐标（用于保存）
    convertDisplayToOriginalCoordinates: function convertDisplayToOriginalCoordinates() {
      var _this6 = this;
      if (!this.form.clickList || this.form.clickList.length === 0) return;
      if (this.scaleX <= 0 || this.scaleY <= 0) return;
      if (!this.isDisplaySizeValid(this.imageDisplayWidth, this.imageDisplayHeight)) return;
      this.clampAllHotspots();
      this.form.clickList.forEach(function (item, index) {
        var display = _this6.clampDisplayCoords(item.left, item.top, item.width, item.height);
        var orig = _this6.clampOriginalCoords(display.left / _this6.scaleX, display.top / _this6.scaleY, display.width / _this6.scaleX, display.height / _this6.scaleY);
        _this6.$set(_this6.form.clickList, index, _objectSpread(_objectSpread({}, item), {}, {
          left: orig.left,
          top: orig.top,
          width: orig.width,
          height: orig.height,
          originalLeft: orig.left,
          originalTop: orig.top,
          originalWidth: orig.width,
          originalHeight: orig.height,
          _isDisplay: false
        }));
      });
    },
    // 鼠标坐标相对于图片显示区域
    getRelativeCoordinates: function getRelativeCoordinates(e) {
      var imgElement = this.$refs.imageRef;
      if (!imgElement) return {
        x: 0,
        y: 0
      };
      var rect = imgElement.getBoundingClientRect();
      return {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      };
    },
    linkUrl: function linkUrl(url) {
      this.$set(this.form.clickList[this.itemIndex], 'url', url);
    },
    openLink: function openLink(index) {
      this.itemIndex = index;
      this.$refs.linkaddressVueRef.dialogVisible = true;
    },
    add: function add() {
      this.updateImageDimensions();
      if (!this.imageReady) {
        this.$message.warning('图片尚未加载完成，请稍后再试');
        return;
      }
      var defaultSize = 50;
      var display = this.clampDisplayCoords(0, 0, Math.min(defaultSize, this.imageDisplayWidth), Math.min(defaultSize, this.imageDisplayHeight));
      this.form.clickList.push({
        name: '',
        url: '',
        left: display.left,
        top: display.top,
        width: display.width,
        height: display.height,
        offlineSupplierId: '',
        originalLeft: display.left / this.scaleX,
        originalTop: display.top / this.scaleY,
        originalWidth: display.width / this.scaleX,
        originalHeight: display.height / this.scaleY,
        _isDisplay: true
      });
    },
    removeHotspot: function removeHotspot(index) {
      this.form.clickList.splice(index, 1);
      if (this.hotspotIndex === index) {
        this.hotspotIndex = null;
        this.isActive = false;
      } else if (this.hotspotIndex > index) {
        this.hotspotIndex -= 1;
      }
    },
    submit: function submit() {
      var _this7 = this;
      this.updateImageDimensions();
      var picW = this.originalPicWidth || this.imageNaturalWidth;
      var picH = this.originalPicHeight || this.imageNaturalHeight;
      if (this.imageReady) {
        this.convertDisplayToOriginalCoordinates();
      } else {
        // 显示尺寸不可信时，回退使用已存的原始坐标，避免误把热区压坏
        this.form.clickList.forEach(function (item, index) {
          var orig = _this7.clampOriginalCoords(item.originalLeft !== undefined ? item.originalLeft : item.left, item.originalTop !== undefined ? item.originalTop : item.top, item.originalWidth !== undefined ? item.originalWidth : item.width, item.originalHeight !== undefined ? item.originalHeight : item.height);
          _this7.$set(_this7.form.clickList, index, _objectSpread(_objectSpread({}, item), {}, {
            left: orig.left,
            top: orig.top,
            width: orig.width,
            height: orig.height,
            originalLeft: orig.left,
            originalTop: orig.top,
            originalWidth: orig.width,
            originalHeight: orig.height,
            _isDisplay: false
          }));
        });
      }

      // 清理临时标记字段
      var cleanedForm = _objectSpread(_objectSpread({}, this.form), {}, {
        clickList: this.form.clickList.map(function (item) {
          var _isDisplay = item._isDisplay,
            cleanedItem = _objectWithoutProperties(item, _excluded);
          return cleanedItem;
        })
      });

      // 出口兜底：保证入库数据一定在 picW × picH 范围内
      var normalized = (0, _hotspotUtils.normalizeHotspotData)(_objectSpread(_objectSpread({}, cleanedForm), {}, {
        picW: picW,
        picH: picH
      }));
      this.$emit('updateForm', normalized.data);
      this.close();
    },
    // ----------拖动位置------------------------------------------------------------------
    mousedown: function mousedown(e, index) {
      this.hotspotIndex = index;
      if (!this.imageReady) return;
      var relativePos = this.getRelativeCoordinates(e);
      var target = this.form.clickList[index];

      // 保存初始位置和鼠标相对位置
      this.$set(this.form.clickList, index, _objectSpread(_objectSpread({}, target), {}, {
        startX: relativePos.x,
        startY: relativePos.y,
        startLeft: target.left,
        startTop: target.top
      }));
      window.addEventListener('mousemove', this.mousemove);
      window.addEventListener('mouseup', this.mouseup);
    },
    mousemove: function mousemove(e) {
      if (this.hotspotIndex === null || !this.imageReady) return;
      var relativePos = this.getRelativeCoordinates(e);
      var target = this.form.clickList[this.hotspotIndex];
      var deltaX = relativePos.x - (target.startX || 0);
      var deltaY = relativePos.y - (target.startY || 0);
      var display = this.clampDisplayCoords((target.startLeft || 0) + deltaX, (target.startTop || 0) + deltaY, target.width, target.height);
      var updatedItem = _objectSpread(_objectSpread({}, this.form.clickList[this.hotspotIndex]), {}, {
        left: display.left,
        top: display.top,
        width: display.width,
        height: display.height
      });
      if (this.scaleX > 0 && this.scaleY > 0) {
        updatedItem.originalLeft = display.left / this.scaleX;
        updatedItem.originalTop = display.top / this.scaleY;
        updatedItem.originalWidth = display.width / this.scaleX;
        updatedItem.originalHeight = display.height / this.scaleY;
      }
      this.$set(this.form.clickList, this.hotspotIndex, updatedItem);
    },
    mouseup: function mouseup() {
      if (this.hotspotIndex !== null) {
        // 清理临时数据
        var target = this.form.clickList[this.hotspotIndex];
        if (target) {
          delete target.startX;
          delete target.startY;
          delete target.startLeft;
          delete target.startTop;
        }
      }
      this.hotspotIndex = null;
      window.removeEventListener('mouseup', this.mouseup);
      window.removeEventListener('mousemove', this.mousemove);
    },
    // -----------激活样式---------------------------------------------------------------
    areaClick: function areaClick(e, index) {
      this.isActive = true;
      this.hotspotIndex = index;
      window.addEventListener('click', this.windowClick);
    },
    windowClick: function windowClick() {
      this.isActive = false;
      this.hotspotIndex = null;
      window.removeEventListener('click', this.windowClick);
    },
    // ------更改大小---------------------------------------------------------
    scaleMousedown: function scaleMousedown(e, index) {
      this.hotspotIndex = index;
      if (!this.imageReady) return;
      var relativePos = this.getRelativeCoordinates(e);
      var target = this.form.clickList[index];

      // 保存初始位置和尺寸
      this.$set(this.form.clickList, index, _objectSpread(_objectSpread({}, target), {}, {
        startX: relativePos.x,
        startY: relativePos.y,
        startWidth: target.width,
        startHeight: target.height
      }));
      window.addEventListener('mousemove', this.scaleMousemove);
      window.addEventListener('mouseup', this.scaleMouseup);
    },
    scaleMousemove: function scaleMousemove(e) {
      if (this.hotspotIndex === null || !this.imageReady) return;
      var relativePos = this.getRelativeCoordinates(e);
      var target = this.form.clickList[this.hotspotIndex];
      var deltaX = relativePos.x - (target.startX || 0);
      var deltaY = relativePos.y - (target.startY || 0);
      var display = this.clampDisplayCoords(target.left, target.top, (target.startWidth || 0) + deltaX, (target.startHeight || 0) + deltaY);
      var updatedItem = _objectSpread(_objectSpread({}, this.form.clickList[this.hotspotIndex]), {}, {
        left: display.left,
        top: display.top,
        width: display.width,
        height: display.height
      });
      if (this.scaleX > 0 && this.scaleY > 0) {
        updatedItem.originalLeft = display.left / this.scaleX;
        updatedItem.originalTop = display.top / this.scaleY;
        updatedItem.originalWidth = display.width / this.scaleX;
        updatedItem.originalHeight = display.height / this.scaleY;
      }
      this.$set(this.form.clickList, this.hotspotIndex, updatedItem);
    },
    scaleMouseup: function scaleMouseup() {
      if (this.hotspotIndex !== null) {
        // 清理临时数据
        var target = this.form.clickList[this.hotspotIndex];
        if (target) {
          delete target.startX;
          delete target.startY;
          delete target.startWidth;
          delete target.startHeight;
        }
      }
      window.removeEventListener('mousemove', this.scaleMousemove);
      window.removeEventListener('mouseup', this.scaleMouseup);
    }
  }
};